import React, {useEffect, useState} from "react";
import {
    typeAnimatedTexts,
    TextChangedCallback,
    typeAnimatedText,
} from "../utils";
import {Box, Group, Text, ThemeIcon, Title} from "@mantine/core";
import classes from "./AskAboutAnimation.module.css";
import {useAnimatedTexts, useSingleShotAnimatedText} from "../hooks";
import IconCircle from "../../../assets/circle2.svg?react";
import {useTranslation} from "react-i18next";

const AskAboutAnimation: React.FC = () => {
    const {t} = useTranslation();

    const texts = [
        t("animation.suggestion.1"),
        t("animation.suggestion.2"),
        t("animation.suggestion.3"),
    ];
    /* const [singleShotText, isFinished] =
        useSingleShotAnimatedText("Spør meg om "); */
    const animatedText = useAnimatedTexts(texts, {
        holdSpeed: 1000,
        loop: false,
        backspaceOnFinish: false,
    });

    const [blink, setBlink] = useState(true);

    useEffect(() => {
        setBlink(false);
        setTimeout(() => {
            setBlink(true);
        }, 500);
    }, [animatedText]);

    return (
        <Title className={classes.title}>
            <Group
                gap="0"
                align="baseline"
                wrap="nowrap"
                style={{whiteSpace: "nowrap"}}
            >
                <Text
                    className={classes.text}
                    display="inline-block"
                    style={{alignItems: "baseline"}}
                >
                    {t("animation.part.0")}{" "}
                    <Text span className={classes.kai}>
                        {t("animation.part.1")}
                    </Text>{" "}
                    {t("animation.part.2")} {animatedText}
                </Text>
                <Text
                    span
                    className={
                        classes.cursor + " " + (blink ? classes.blink : "")
                    }
                    c="var(--kai-brand-base)"
                />
            </Group>
        </Title>
    );
};

export default AskAboutAnimation;
